import React from "react";
import className from "classnames/bind";
import useTranslations from "../../hooks/useTranslations";

/**
 * Component hiển thị thông tin khách hàng
 * @param {Object} props
 * @param {Object} props.customerInfo - Thông tin khách hàng
 * @param {Object} props.styles - SCSS styles object
 */
const CustomerInfo = ({ customerInfo, styles }) => {
  const cx = className.bind(styles);
  const translations = useTranslations();

  if (!customerInfo) {
    return <div className={cx("section")}>No customer information available</div>;
  }

  return (
    <div className={cx("customer-info")}>
      <div className={cx("section")}>
        <p>
          <strong>{translations?.PaymentSuccess?.name || "Name"}:</strong>{" "}
          {customerInfo.name || 'N/A'}
        </p>
        <p>
          <strong>{translations?.PaymentSuccess?.email || "Email address"}:</strong>{" "}
          {customerInfo.email || 'N/A'}
        </p>
        <p>
          <strong>{translations?.PaymentSuccess?.phone || "Phone number"}:</strong>{" "}
          {customerInfo.phone || 'N/A'}
        </p>
        <p>
          <strong>{translations?.PaymentSuccess?.shipping_address || "Shipping Address"}:</strong>{" "}
          {customerInfo.shippingAddress || 'N/A'}
        </p>
      </div>
    </div>
  );
};

export default CustomerInfo;
